/*
 * @Author: 王新
 * @Date: 2021-04-28 10:19:17
 * @FilePath: \operation-screen\src\config\config.js
 * @Description: 描述信息
 */
// let baseUrl = "http://192.168.6.57:8769"
// let baseUrl = "http://47.96.14.66:8769" // 测试环境 
// let baseUrl = "http://101.37.157.129:8769" // 正式
let baseUrl = "http://kyyapi.zhongshelian.com" // 正式
export default {
    baseUrl
}